export enum SttMarkerType {
  Appearance = 'appearance',
  AutoGeneratedHearing = 'auto-generated-hearing',
  Event = 'event',
  Hearing = 'hearing',
  Sealing = 'sealing',
  Session = 'session',
}
